var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSepolia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#627EEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.498 4V12.87L23.995 16.22L16.498 4Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.498 4L9 16.22L16.498 12.87V4Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.498 21.968V27.995L24 17.616L16.498 21.968Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.498 27.995V21.967L9 17.616L16.498 27.995Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.498 20.573L23.995 16.22L16.498 12.872V20.573Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.22L16.498 20.573V12.872L9 16.22Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8H10V11H14V24H18V11H22V8Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSepolia);
export default __webpack_public_path__ + "static/media/sepolia.567c55d878860713d5679db3e20a078f.svg";
export { ForwardRef as ReactComponent };